@if ((isInvitationLoading$ | async) === false) {
  <img [src]="mercuryLogoPath" alt="Mercury Logo" class="mercury-logo" />

  @if ((isInvitationModelValid$ | async) === true) {
    <div class="col-12 body-medium text-tertiary subtitle-gap p-0">Sign Up</div>
    <div class="col-12 jumbo-medium text-primary title-gap p-0">
      Welcome to Mercury
    </div>
    <div class="col-12 body-medium text-tertiary paragraph-gap p-0">
      To finish signing up, please create a password
    </div>
    <form [formGroup]="form" class="grid w-full m-0 p-0">
      <div class="col-12 p-0 form-elements">
        <div class="form-group field-label-medium text-tertiary">
          <div class="mb-2">
            <label>Password</label>
          </div>
          <div class="form-control p-fluid input-text">
            <p-password
              [strongRegex]="strongRegex"
              [toggleMask]="true"
              formControlName="password"
              inputStyleClass="w-full"
              appendTo="body"
              class="p-input-icon-right"
            >
              <ng-template #header>
                <span class="subtitle-small text-secondary">
                  Pick a password
                </span>
              </ng-template>
              <ng-template #footer>
                <p-divider></p-divider>
                <me-password-rules
                  [passwordControl]="password"
                ></me-password-rules>
              </ng-template>
            </p-password>
            <me-form-validation-message
              controlName="password"
              label="Password"
            ></me-form-validation-message>
          </div>
        </div>
      </div>

      <div class="col-12 p-0 form-elements mb-3">
        <div class="form-group field-label-medium text-tertiary">
          <div class="mb-2">
            <label>Confirm Password</label>
          </div>
          <div class="form-control p-fluid input-text">
            <p-password
              [feedback]="false"
              [toggleMask]="true"
              formControlName="passwordRepeat"
              inputStyleClass="w-full"
              class="p-input-icon-right"
            >
            </p-password>

            @if (form.get('passwordRepeat')?.dirty) {
              <me-form-validation-message
                [displayGroupErrors]="true"
                controlName="passwordRepeat"
                label="Confirm password"
              ></me-form-validation-message>
            }
          </div>
        </div>
      </div>

      @if (termsAndConditionsNeeded) {
        <div class="field-checkbox mt-4 mb-4">
          <p-checkbox
            (onChange)="handleTermsChange($event)"
            [binary]="true"
            formControlName="checkboxControl"
            name="labelUpdated"
            class="me-checkbox-primary mr-1"
          ></p-checkbox>
          <label class="field-label-medium text-secondary"
            >I agree to the
            <label
              (click)="toggleTermsAndConditionsModal(true)"
              class="terms-text"
              >Terms and Conditions</label
            >
          </label>
        </div>
      }

      <div class="col-12 p-0">
        <button
          (click)="
            enableRecaptchaFlag && !useTurnstile
              ? submitRequestWithCaptcha()
              : sendCreateFirstUserPasswordRequest()
          "
          [disabled]="
            (isRequestInProgress$ | async) === true ||
            form.invalid ||
            password.value !== passwordRepeat.value ||
            !token
          "
          [loading]="!!(isRequestInProgress$ | async)"
          class="p-button-primary w-full button-text-medium"
          pButton
        >
          <span pButtonLabel>Login</span>
        </button>
      </div>
    </form>
  } @else {
    <div class="col-12 body-medium text-tertiary subtitle-gap p-0">
      Create Account
    </div>
    <div class="col-12 jumbo-medium text-primary title-gap p-0">
      Link Invalid
    </div>
    <div class="col-12 body-medium text-tertiary description-gap p-0">
      This link has either expired or been used already. Please contact your
      administrator to receive another link.
    </div>

    <div class="col-12 p-0">
      <button
        class="p-button-primary w-full button-text-medium"
        pButton
        routerLink="/login"
      >
        <span pButtonLabel>Back to Login</span>
      </button>
    </div>
  }
}

@if (enableRecaptchaFlag) {
  @if (useTurnstile) {
    <div
      #turnstileRef
      class="turnstile-container flex justify-content-center mt-3"
    ></div>
  } @else {
    <re-captcha
      #captchaRef
      (resolved)="resolved($event)"
      [siteKey]="captchaPublicSiteKey"
      size="invisible"
    ></re-captcha>
  }
}

<au-custom-dialog
  (cancelChange)="toggleTermsAndConditionsModal(false)"
  (submitChange)="agreeTerms()"
  [isDialogVisible]="toggleTermsModal"
  [showCancelButton]="false"
  [showSubmitButton]="true"
  dialogTitle="Terms and Conditions"
  submitButtonText="Agree"
>
  <div [innerHTML]="safeTermsHtml" class="terms-modal-text p-2"></div>
</au-custom-dialog>
